<template>
    <div>
        <el-row :gutter="24">
            <el-col :span="24">
                 <el-alert
                    title="正在跳转..."
                    type="info"
                    show-icon>
                </el-alert>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { getWeixinAuthUrl,getJsApiConfig } from '../../api/weixin';

export default {
    data () {
        return {
            redirectUrl: ''
        }
    },
    methods: {
        getUrl(){
            getWeixinAuthUrl({suffix:""}).then(data => {
                window.location.href= data.response;
            });
        },
    },
    mounted () {
        this.getUrl();
    }
}
</script>